import ApiClient from "@common/api/ApiClient";

/**
 * Compliance API Comment routes (base from session `comp_api_url`, e.g. …/Comment/Create).
 */
class CommentClient extends ApiClient {
  constructor() {
    super("Comment");
    this.setApiUrlKey("comp_api_url");
  }

  Create = async (payload) => await this.post("Create", payload);
}

const client = new CommentClient();

export default client;
